import React from 'react'
import { PageHeading, Heading, Text, Link } from '../../../shared/typography'
import { StackView, Divider } from '@planningcenter/tapestry-react'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Add-ons Guidelines</PageHeading>

      <Text>
        Planning Center Add-ons provide a great way for our mutual customers to
        use our platforms seamlessly. We're excited that you've decided to work
        with us, and we're here to support you.
      </Text>
      <Text>
        These guidelines exist to help us create add-ons with maximum customer
        impact by being consistent, reliable, and safe. By following these
        guidelines, we ensure that we're not only building integrations but
        creating delightful user experiences.
      </Text>
      <Text>Expect these guidelines to evolve alongside our platform.</Text>

      <Heading>Use Cases</Heading>
      <Text>
        Your add-on should enable a user to have a seamless experience
        completing your platform's main use cases without leaving their church
        management system (Planning Center). That means if you are integrating a
        messaging platform, sending messages should be the focus of your add-on.
        It's okay and even expected for a user to return to your platform to
        manage things like configuration and/or less used functionality.
      </Text>

      <Heading>Design</Heading>
      <Text>
        Add-ons should feel familiar to Planning Center users. Using the
        components in the{' '}
        <Link to="https://planningcenter.github.io/add-ons-js" external>
          Component Library
        </Link>{' '}
        as they were intended will go a long way towards making user interfaces
        that are consistent and predictable.
      </Text>

      <Heading>Reliability</Heading>
      <Text>
        Before submitting your add-on for release, give it a thorough QA pass.
        Be sure to test not only the golden path, but ways in which users might
        get caught up. Test empty states, overflow states, and authentication
        failures. It is imperative that add-ons are high quality and reliable.
      </Text>

      <Heading>Authentication</Heading>
      <Text>
        Users should authenticate your add-on with your platform using a
        standard OAuth flow. Don’t ask for API keys, personal access tokens, or
        use basic auth.
      </Text>

      <Heading>Monetization</Heading>
      <Text>
        As of now there are no built-in monetization or payment options for
        add-ons. Any actions taken by a user that will trigger a billable event
        (e.g., ordering a background check) should charge the billing
        information that is on file for their account on your platform. Don't
        collect payment information in the add-on.
      </Text>

      <Divider />

      <Text>
        If you have any questions, please reach out! We’re here to support you
        in making great experiences for our mutual customers.
      </Text>
      <Text>Happy integrating! 🚀</Text>
    </StackView>
  )
}

export default page
